import { isFunction } from "@components/config/helpers";

export const successfulRes = (res) => {
    return res?.status == 'success';
}

export const failedRes = (res) => {
    return !res?.status || res?.status == 'failed' || res?.status == 'warning';
}

export const handleRequest = async (func, options = { onSubmitting: (e) => null, onSuccess: (e) => null, onError: (e) => null, onFinish: (e) => null }) => {

    if (isFunction(options.onSubmitting)) {
        await options.onSubmitting();
    }

    const res = await func();

    if (isFunction(options.onSuccess)) {
        const succeeded = successfulRes(res);
        if (succeeded) await options.onSuccess(res);
    }
    if (isFunction(options.onError)) {
        const failed = failedRes(res);
        if (failed) await options.onError(res);
    }
    if (isFunction(options.onFinish)) {
        await options.onFinish(res);
    }
    return res;
}

export const getNextApi = (url) => {
    const api = process.env.NODE_ENV == 'development' ? '/api' : '/_api';
    return `${api}/${url}`;
}

export function getClientIp(req) {
    const cloudflareIp = req.headers['cf-connecting-ip'];
    const forwardedFor = req.headers['x-forwarded-for'];

    const clientIp =
        cloudflareIp ||
        (forwardedFor
            ? forwardedFor.split(',')[0].trim()
            : null) ||
        req.socket?.remoteAddress ||
        null;

    const headers = {
        Accept: 'application/json',
        'X-Client-IP': clientIp || '',
    };

    if (process.env.INTERNAL_API_TOKEN) {
        headers['X-Internal-Token'] = process.env.INTERNAL_API_TOKEN;
    }

    return {
        clientIp,
        headers,
    };
}